module.exports = __webpack_public_path__ + "static/media/605.6eac4946.webp";